import { computed, onMounted, reactive, ref } from '@vue/runtime-core';
import router from '@/router/index.js';
import { showToast } from 'vant';
import { useStore } from 'vuex';
import storeState from './store/index';
// const homeA = require('https://video-h5.wqxsw.com/ttyd/img/home-active.png')
// const homeB = require('https://video-h5.wqxsw.com/ttyd/img/home.png')
export default {
  name: 'App',
  components: {},
  setup() {
    let isShowTab = ref(false);
    let showModal = ref(false);
    let token = computed(() => storeState.getters.token);
    let ksData = reactive({
      err: []
    });
    let store = useStore();
    onMounted(() => {
      window.addEventListener("offline", () => {
        showToast('网络已断开');
      });
      window.addEventListener("online", () => {
        showToast('网络已连接');
      });
      if (token.value) store.dispatch('GetUserInfo', {});
    });

    // 监听当前页面是否是tab页面
    router.afterEach(to => {
      let tabList = ['/', '/home', '/list', '/mine', '/tdata'];
      if (tabList.indexOf(to.path) > -1) {
        isShowTab.value = true;
      } else {
        isShowTab.value = false;
      }
    });
    return {
      isShowTab,
      showModal,
      ksData
    };
  }
};